import { Injectable, OnDestroy } from '@angular/core';
import { TimeframeData } from '../interfaces/TimeframeData';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

type timeframeType = {
    [key: string]: number;
};

@Injectable({
    providedIn: 'root',
})
export class TimeframeService implements OnDestroy {
    private selectedTimeframeSubject: BehaviorSubject<TimeframeData | null>;

    private timeframeMapping: timeframeType = {
        '24h': 1,
        '7d': 7,
        '30d': 30,
    };

    public constructor(protected http: HttpClient) {
        this.readSelectedTimeframeData(null);
    }

    public ngOnDestroy() {
        this.selectedTimeframeSubject?.unsubscribe();
    }

    /**
     * This observable will reflect the changes in the company selector.
     */
    public selectedTimeframe$(): Observable<TimeframeData | null> {
        return this.selectedTimeframeSubject.asObservable();
    }

    /**
     * Note that this method will return the timeframe id
     * that is selected _at the moment of the call_.
     * Subscribe to `selectedOrganization$()` if you need to be notified when the selection changes.
     */
    public currentlySelectedTimeframe(): TimeframeData | null {
        return this.selectedTimeframeSubject.getValue();
    }

    public getTimeframeDays(timeframe: string): number {
        return this.timeframeMapping[timeframe];
    }

    /**
     * Check if the newly logged user already selected a timeframe, otherwise select '24h' option
     * @param SelectedTimeframe
     */
    public initializeSelectedTimeframe(SelectedTimeframe: TimeframeData | null): void {
        if (localStorage.getItem('timeframe')) {
            /* the user just changed the page while still being logged in, so keep using the timeframe */
            SelectedTimeframe = this.currentlySelectedTimeframe();
        } else {
            this.selectTimeframe({
                id: 1,
                name: '24h',
                label: 'Last 24 hours',
            });
        }
    }

    public selectTimeframe(timeframe: TimeframeData | null) {
        this.selectedTimeframeSubject.next(timeframe);
        localStorage.setItem('timeframe', JSON.stringify(timeframe));
    }

    private readSelectedTimeframeData(timeframe: TimeframeData | null) {
        const savedTimeframeData = localStorage.getItem('timeframe');
        let selectedTimeframe: TimeframeData | null = null;

        try {
            selectedTimeframe = !savedTimeframeData ? null : JSON.parse(savedTimeframeData);
        } catch (e) {
            console.error('Cannot parse selected timeframe data');
        }

        this.selectedTimeframeSubject = new BehaviorSubject<TimeframeData | null>(selectedTimeframe);
    }
}
